import React, { Component } from 'react';
import { photos_url, directory } from '../config';
import totalCartItems from './totalCartItems';

class Cart extends Component {
  returnPhotos() {
    const photos = JSON.parse(localStorage.checkout);

    photos.reverse();
    return photos.map((photo, i) => {
      return (
        <div key={i} className="cart-item">
          <div className="image-qt">x {photo.qt}</div>
          <div className="image" style={{ backgroundImage: `url(${photos_url}/${directory}/images/thumbnails/${photo.file})` }}>
            <button type="button" className="cart-image-button" onClick={() => this.props.onClickPhotoCart(photo.file)}></button>
          </div>
          <div>
            <button type="button" className="remove-cart-image-button" onClick={() => this.props.onClickPhotoRemoveCart(photo.file)}>Apagar</button>
          </div>
        </div>
      )
    });
  }

  render() {
    return (
      <div>
        {this.returnPhotos()}
        <div className="cart-footer text-center">
          Total: {totalCartItems()} €<br />
          <button onClick={this.props.payButton} type="button" className="pay-button">Finalizar encomenda</button>
        </div>
      </div>
    );
  }
}

export default Cart;


// WEBPACK FOOTER //
// ./src/components/Cart.js